export default __webpack_public_path__ + "static/media/1 (10).8137bc2f.jpg";